import { render } from "./Decorations.vue?vue&type=template&id=17f137d0&scoped=true"
const script = {}

import "./Decorations.vue?vue&type=style&index=0&id=17f137d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f137d0"]])

export default __exports__